import React from "react";
import { Modal } from "./Modal";
import {googleCalendarLink, outlookCalendarLink} from "../data/calendar-event";
import { PiMicrosoftOutlookLogo } from "react-icons/pi";

interface CalendarModalProps {
    isOpen: boolean;
    onClose: () => void;
}

export const CalendarModal: React.FC<CalendarModalProps> = ({ isOpen, onClose }) => {
    const handleGoogle = () => {
        window.open(googleCalendarLink, "_blank", "noopener,noreferrer");
        onClose();
    };
    const handleOutlook = () => {
        window.open(outlookCalendarLink, "_blank", "noopener,noreferrer");
        onClose();
    };

    return (
        <Modal
            isOpen={isOpen}
            onClose={onClose}
            title="Agregar a mi calendario"
            size="md"
        >
            {/*<p className="mb-6 text-center text-gray-600">Selecciona tu calendario preferido:</p>*/}

            <div className="grid gap-3">
                <button
                    onClick={handleGoogle}
                    className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-(--primary-color) py-3 px-4 text-white transition-colors hover:bg-(--hover-color) focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 focus-visible:ring-[#1a73e8]"
                >
                    <svg className="h-5 w-5" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
                        <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z"/>
                        <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z"/>
                        <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z"/>
                        <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z"/>
                    </svg>
                    <span>Google</span>
                </button>

                <button
                    onClick={handleOutlook}
                    className="inline-flex w-full items-center justify-center gap-2 rounded-md bg-(--primary-color) py-3 px-4 text-white transition-colors hover:bg-(--hover-color) focus:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 "
                >
                    {PiMicrosoftOutlookLogo({size: 24, color: 'white'})}
                    <span>Outlook</span>
                </button>
            </div>
        </Modal>
    );
};